'use client';

import { useContext } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { Typography, Stack, Chip } from '@mui/material';
import { formatDate } from '@qb/frontend/utils/dateFormatter';
import { TenantStoreContext } from '@/global/tenantStore/TenantStoreContext';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
export const PartOnHandQuantityStatus = ({
  publicQtyAndPrice
}: Pick<PartDisplayDataResponse, 'publicQtyAndPrice'>) => {
  const context = useContext(TenantStoreContext);
  const combinedStock = publicQtyAndPrice.onHandQty + publicQtyAndPrice.manufacturerStock;
  const hasStock = combinedStock > 0;
  if (!hasStock) {
    return null;
  }

  // For now, going to just use today's date
  const updatedAt = formatDate(new Date(), context?.appInfo?.app?.timeZone || 'America/Los_Angeles');
  const isLowStock = combinedStock <= 5;
  const label = isLowStock ? `Only ${combinedStock.toLocaleString()} left in stock. Order Now!` : `${combinedStock.toLocaleString()} in stock`;
  return <Stack data-cy="OutsideWrapper" direction="row" sx={{
    mt: 1,
    pl: 1,
    gap: 1,
    alignItems: 'center',
    mb: [1, 1, 1.5]
  }} data-sentry-element="Stack" data-sentry-component="PartOnHandQuantityStatus" data-sentry-source-file="PartOnHandQuantityStatus.tsx">
      <Chip size="small" icon={isLowStock ? <NewReleasesIcon /> : <CheckCircleIcon />} label={label} sx={{
      bgcolor: '#00ED8E',
      color: 'text.primary',
      '.MuiChip-icon': {
        color: 'text.primary'
      }
    }} data-sentry-element="Chip" data-sentry-source-file="PartOnHandQuantityStatus.tsx" />
      {!!updatedAt && <Typography variant="bodySmall" sx={{
      color: 'text.primary'
    }}>
          {updatedAt}
        </Typography>}
    </Stack>;
};